export default __webpack_public_path__ + "static/media/Snow Fairy.8e54cc67.mp3";